import { render } from "./DisabilityForm.vue?vue&type=template&id=7d734882"
import script from "./DisabilityForm.vue?vue&type=script&lang=js"
export * from "./DisabilityForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__